module.exports = __webpack_public_path__ + "img/success.c2938530.png";